export default "__VITE_ASSET__DK5X3qfM__"